package org.hs_soft.runmynesto.domain.model.home.customer_card.tabs.card

import androidx.compose.runtime.Composable
import org.hs_soft.runmynesto.domain.util.helper.LanguageManager
import org.hs_soft.runmynesto.domain.util.helper.Strings

enum class TransactionColumnsEnum(val value: Boolean) {
    FROM_DATE(true),
    GROUP(false),
    USER_NAME(true),
    BALANCE(false),
    BOOKING_MODE(false),
    UNTIL_DATE(true),
    CHECKOUT(true),
    CREDIT(true),
    POINTS(false),
    CHECKOUT_DATE(false),
    DESIGNATION(true),
    DOCUMENT_NUMBER(true),
    BURDEN(false),
    POINTS_BALANCE(false),
    CASH_REGISTER_TIME(false);

    @Composable
    fun getTitle(): String {
        val strings = Strings.current()
        return when (this) {
            FROM_DATE -> strings.FROM_DATE
            GROUP -> strings.GROUP
            USER_NAME -> strings.USER_NAME
            BALANCE -> strings.BALANCE
            BOOKING_MODE -> strings.BOOKING_MODE
            UNTIL_DATE -> strings.UNTIL_DATE
            CHECKOUT -> strings.CHECKOUT
            CREDIT -> strings.CREDIT
            POINTS -> strings.POINTS
            CHECKOUT_DATE -> strings.CHECKOUT_DATE
            DESIGNATION -> strings.DESIGNATION
            DOCUMENT_NUMBER -> strings.DOCUMENT_NUMBER
            BURDEN -> strings.BURDEN
            POINTS_BALANCE -> strings.POINTS_BALANCE
            CASH_REGISTER_TIME -> strings.CASH_REGISTER_TIME
        }
    }

    val title: String
        get() = LanguageManager.getCurrentStrings().let { strings ->
            when (this) {
                FROM_DATE -> strings.FROM_DATE
                GROUP -> strings.GROUP
                USER_NAME -> strings.USER_NAME
                BALANCE -> strings.BALANCE
                BOOKING_MODE -> strings.BOOKING_MODE
                UNTIL_DATE -> strings.UNTIL_DATE
                CHECKOUT -> strings.CHECKOUT
                CREDIT -> strings.CREDIT
                POINTS -> strings.POINTS
                CHECKOUT_DATE -> strings.CHECKOUT_DATE
                DESIGNATION -> strings.DESIGNATION
                DOCUMENT_NUMBER -> strings.DOCUMENT_NUMBER
                BURDEN -> strings.BURDEN
                POINTS_BALANCE -> strings.POINTS_BALANCE
                CASH_REGISTER_TIME -> strings.CASH_REGISTER_TIME
            }
        }
}